import {Tr} from "@/i18n/i18n";
import {PlayerAction} from "@/store/profile/types";

export default class ProfileUtils {
    public static getActionName(pa: PlayerAction): string {
        switch (pa) {
            case PlayerAction.BLOCK:
                return Tr('to.blck.list');
            case PlayerAction.UNBLOCK:
                return Tr('from.blck.list');
        }
        return '';
    }

    public static getActionText(pa: PlayerAction): string {
        switch (pa) {
            case PlayerAction.BLOCK:
                return Tr('block.user');
            case PlayerAction.UNBLOCK:
                return Tr('unblock.user');
        }
        return '';
    }

    public static getActionFeed(pa: PlayerAction): string {
        switch (pa) {
            case PlayerAction.BLOCK:
                return Tr('blocked.feed');
            case PlayerAction.UNBLOCK:
                return Tr('unblocked.feed');
        }
        return '';
    }
}
